import React from "react";

const Java_nextAfter = () => {
  return (
    <div>
      <h1>Java nextAfter</h1>
      <p>This page provides explanations, examples, and common use-cases for Java nextAfter in Java.</p>
    </div>
  );
};

export default Java_nextAfter;
